import { FlagProps } from '@boltenergy-be/design-system'
import { ReactNode } from 'react'

export type BannerProps = {
  onClick: () => void
}

export enum BannerTypes {
  BRUSSELS_BEER_PROJECT = 'brusselsBeerProject',
  MIDDLE_EAST_ENERGY_CRISIS = 'middleEastEnergyCrisis',
  VIA_VIA = 'copy',
  SIMULATION_DOWN = 'simulationDown',
  SCHEDULED_DOWNTIME = 'scheduledDowntime',
  PRICE_BANNER = 'priceBanner'
}

export type PredefinedBanner = {
  singleLine?: boolean
  noOnClick?: boolean
  className?: string
} & Pick<FlagProps, 'type' | 'size' | 'icon'> &
  (
    | {
        titleNsAndKey: string
        descriptionNsAndKey?: string
        text?: never
      }
    | {
        text: string | ReactNode
        titleNsAndKey?: never
        descriptionNsAndKey?: never
      }
  )
